"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.esZones = exports.esSubZoneNameMapping = void 0;
var esZones = exports.esZones = [{
  id: 'BARCELONA',
  name: 'Barcelone',
  country: 'ES',
  cornerNW: {
    latitude: 41.4695,
    longitude: 2.0787
  },
  cornerSE: {
    latitude: 41.3471,
    longitude: 2.2287
  },
  subZones: [{
    name: 'Ciutat Viella',
    zipcodes: {
      '08001': {
        label: '08001'
      },
      '08002': {
        label: '08002'
      },
      '08003': {
        label: '08003'
      }
    }
  }, {
    name: 'Eixample',
    zipcodes: {
      '08007': {
        label: '08007'
      },
      '08008': {
        label: '08008'
      },
      '08009': {
        label: '08009'
      },
      '08010': {
        label: '08010'
      },
      '08011': {
        label: '08011'
      },
      '08013': {
        label: '08013'
      },
      '08015': {
        label: '08015'
      },
      '08025': {
        label: '08025'
      },
      '08036': {
        label: '08036'
      }
    }
  }, {
    name: 'Sants-Montjuïc',
    zipcodes: {
      '08004': {
        label: '08004'
      },
      '08014': {
        label: '08014'
      },
      '08038': {
        label: '08038'
      },
      '08039': {
        label: '08039'
      },
      '08040': {
        label: '08040'
      }
    }
  }, {
    name: 'Les Corts',
    zipcodes: {
      '08014': {
        label: '08014'
      },
      '08028': {
        label: '08028'
      },
      '08029': {
        label: '08029'
      },
      '08034': {
        label: '08034'
      }
    }
  }, {
    name: 'Sarrià-Sant Gervasi',
    zipcodes: {
      '08006': {
        label: '08006'
      },
      '08017': {
        label: '08017'
      },
      '08021': {
        label: '08021'
      },
      '08022': {
        label: '08022'
      },
      '08023': {
        label: '08023'
      },
      '08034': {
        label: '08034'
      }
    }
  }, {
    name: 'Gràcia',
    zipcodes: {
      '08012': {
        label: '08012'
      },
      '08023': {
        label: '08023'
      },
      '08024': {
        label: '08024'
      },
      '08037': {
        label: '08037'
      }
    }
  }, {
    name: 'Horta-Guinardó',
    zipcodes: {
      '08025': {
        label: '08025'
      },
      '08031': {
        label: '08031'
      },
      '08032': {
        label: '08032'
      },
      '08035': {
        label: '08035'
      },
      '08041': {
        label: '08041'
      }
    }
  }, {
    name: 'Nou Barris',
    zipcodes: {
      '08016': {
        label: '08016'
      },
      '08033': {
        label: '08033'
      },
      '08042': {
        label: '08042'
      }
    }
  }, {
    name: 'Sant Andreu',
    zipcodes: {
      '08027': {
        label: '08027'
      },
      '08030': {
        label: '08030'
      },
      '08020': {
        label: '08020'
      }
    }
  }, {
    name: 'Sant Martí',
    zipcodes: {
      '08005': {
        label: '08005'
      },
      '08018': {
        label: '08018'
      },
      '08019': {
        label: '08019'
      },
      '08020': {
        label: '08020'
      },
      '08026': {
        label: '08026'
      }
    }
  }]
}, {
  id: 'BILBAO',
  name: 'Bilbao',
  country: 'ES',
  cornerNW: {
    latitude: 43.2897,
    longitude: -2.9897
  },
  cornerSE: {
    latitude: 43.2261,
    longitude: -2.9119
  },
  subZones: [{
    name: 'Bilbao',
    zipcodes: {
      48001: {
        label: 'Casco Viejo'
      },
      48002: {
        label: 'Abando'
      },
      48003: {
        label: 'Uribarri'
      },
      48004: {
        label: 'Begoña'
      },
      48005: {
        label: 'Deusto'
      }
    }
  }]
}, {
  id: 'LAS_PALMAS',
  name: 'Las Palmas',
  country: 'ES',
  cornerNW: {
    latitude: 28.1727,
    longitude: -15.4897
  },
  cornerSE: {
    latitude: 28.0894,
    longitude: -15.4119
  },
  subZones: [{
    name: 'Las Palmas',
    zipcodes: {
      35001: {
        label: 'Vegueta'
      },
      35002: {
        label: 'Triana'
      },
      35003: {
        label: 'Arenales'
      },
      35004: {
        label: 'Ciudad Jardín'
      },
      35005: {
        label: 'Puerto-Canteras'
      }
    }
  }]
}, {
  id: 'MADRID',
  name: 'Madrid',
  country: 'ES',
  cornerNW: {
    latitude: 40.5638,
    longitude: -3.8349
  },
  cornerSE: {
    latitude: 40.3120,
    longitude: -3.5201
  },
  subZones: [{
    name: '01 - Centro',
    zipcodes: {
      28001: {
        label: '28001'
      },
      28004: {
        label: '28004'
      },
      28012: {
        label: '28012'
      },
      28013: {
        label: '28013'
      },
      28014: {
        label: '28014'
      },
      28005: {
        label: '28005'
      }
    }
  }, {
    name: '02 - Arganzuela',
    zipcodes: {
      28045: {
        label: '28045'
      },
      28012: {
        label: '28012'
      }
    }
  }, {
    name: '03 - Retiro',
    zipcodes: {
      28007: {
        label: '28007'
      },
      28009: {
        label: '28009'
      }
    }
  }, {
    name: '04 - Salamanca',
    zipcodes: {
      28001: {
        label: '28001'
      },
      28006: {
        label: '28006'
      },
      28009: {
        label: '28009'
      }
    }
  }, {
    name: '05 - Chamartín',
    zipcodes: {
      28016: {
        label: '28016'
      },
      28036: {
        label: '28036'
      }
    }
  }, {
    name: '06 - Tetuán',
    zipcodes: {
      28020: {
        label: '28020'
      },
      28039: {
        label: '28039'
      }
    }
  }, {
    name: '07 - Chamberí',
    zipcodes: {
      28010: {
        label: '28010'
      },
      28015: {
        label: '28015'
      }
    }
  }, {
    name: '08 - Fuencarral-El Pardo',
    zipcodes: {
      28034: {
        label: '28034'
      },
      28035: {
        label: '28035'
      },
      28029: {
        label: '28029'
      }
    }
  }, {
    name: '09 - Moncloa-Aravaca',
    zipcodes: {
      28008: {
        label: '28008'
      },
      28011: {
        label: '28011'
      },
      28023: {
        label: '28023'
      }
    }
  }, {
    name: '10 - Latina',
    zipcodes: {
      28024: {
        label: '28024'
      },
      28025: {
        label: '28025'
      },
      28047: {
        label: '28047'
      }
    }
  }, {
    name: '11 - Carabanchel',
    zipcodes: {
      28019: {
        label: '28019'
      },
      28025: {
        label: '28025'
      },
      28026: {
        label: '28026'
      }
    }
  }, {
    name: '12 - Usera',
    zipcodes: {
      28026: {
        label: '28026'
      },
      28041: {
        label: '28041'
      }
    }
  }, {
    name: '13 - Puente de Vallecas',
    zipcodes: {
      28018: {
        label: '28018'
      },
      28053: {
        label: '28053'
      }
    }
  }, {
    name: '14 - Moratalaz',
    zipcodes: {
      28030: {
        label: '28030'
      },
      28031: {
        label: '28031'
      }
    }
  }, {
    name: '15 - Ciudad Lineal',
    zipcodes: {
      28017: {
        label: '28017'
      },
      28027: {
        label: '28027'
      },
      28043: {
        label: '28043'
      }
    }
  }, {
    name: '16 - Hortaleza',
    zipcodes: {
      28033: {
        label: '28033'
      },
      28043: {
        label: '28043'
      }
    }
  }, {
    name: '17 - Villaverde',
    zipcodes: {
      28021: {
        label: '28021'
      },
      28041: {
        label: '28041'
      }
    }
  }, {
    name: '18 - Villa de Vallecas',
    zipcodes: {
      28031: {
        label: '28031'
      },
      28051: {
        label: '28051'
      }
    }
  }, {
    name: '19 - Vicálvaro',
    zipcodes: {
      28032: {
        label: '28032'
      }
    }
  }, {
    name: '20 - San Blas-Canillejas',
    zipcodes: {
      28022: {
        label: '28022'
      },
      28037: {
        label: '28037'
      }
    }
  }, {
    name: '21 - Barajas',
    zipcodes: {
      28042: {
        label: '28042'
      }
    }
  }, {
    name: '22 - Cuenca',
    zipcodes: {
      16001: {
        label: '16001'
      },
      16002: {
        label: '16002'
      },
      16003: {
        label: '16003'
      },
      16004: {
        label: '16004'
      },
      16070: {
        label: '16070'
      },
      16071: {
        label: '16071'
      },
      16080: {
        label: '16080'
      }
    }
  }]
}, {
  id: 'MALAGA',
  name: 'Málaga',
  country: 'ES',
  cornerNW: {
    latitude: 36.7527,
    longitude: -4.4897
  },
  cornerSE: {
    latitude: 36.6894,
    longitude: -4.4119
  },
  subZones: [{
    name: 'Málaga',
    zipcodes: {
      29001: {
        label: 'Centro Histórico'
      },
      29002: {
        label: 'La Trinidad'
      },
      29003: {
        label: 'El Perchel'
      },
      29004: {
        label: 'La Malagueta'
      },
      29005: {
        label: 'El Limonar'
      }
    }
  }]
}, {
  id: 'MURCIA',
  name: 'Murcie',
  country: 'ES',
  cornerNW: {
    latitude: 38.0127,
    longitude: -1.1897
  },
  cornerSE: {
    latitude: 37.9494,
    longitude: -1.1119
  },
  subZones: [{
    name: 'Murcia',
    zipcodes: {
      30001: {
        label: 'Centro'
      },
      30002: {
        label: 'San Juan'
      },
      30003: {
        label: 'San Andrés'
      },
      30004: {
        label: 'La Fama'
      },
      30005: {
        label: 'Santa Eulalia'
      }
    }
  }]
}, {
  id: 'PALMA',
  name: 'Palma de Majorque',
  country: 'ES',
  cornerNW: {
    latitude: 39.5897,
    longitude: 2.6119
  },
  cornerSE: {
    latitude: 39.5261,
    longitude: 2.6897
  },
  subZones: [{
    name: 'Palma de Majorque',
    zipcodes: {
      '07001': {
        label: 'Centro Histórico'
      },
      '07002': {
        label: 'La Lonja'
      },
      '07003': {
        label: 'Santa Catalina'
      },
      '07004': {
        label: 'Son Armadams'
      },
      '07005': {
        label: 'El Terreno'
      }
    }
  }]
}, {
  id: 'SEVILLE',
  name: 'Séville',
  country: 'ES',
  cornerNW: {
    latitude: 37.4227,
    longitude: -6.0119
  },
  cornerSE: {
    latitude: 37.3594,
    longitude: -5.9341
  },
  subZones: [{
    name: 'Séville',
    zipcodes: {
      41001: {
        label: 'Casco Antiguo'
      },
      41002: {
        label: 'Macarena'
      },
      41003: {
        label: 'Nervión'
      },
      41004: {
        label: 'Triana'
      },
      41005: {
        label: 'Los Remedios'
      }
    }
  }]
}, {
  id: 'VALENCIA',
  name: 'Valence',
  country: 'ES',
  cornerNW: {
    latitude: 39.5027,
    longitude: -0.4119
  },
  cornerSE: {
    latitude: 39.4394,
    longitude: -0.3341
  },
  subZones: [{
    name: 'Valence',
    zipcodes: {
      46001: {
        label: 'Ciutat Vella'
      },
      46002: {
        label: 'L\'Eixample'
      },
      46003: {
        label: 'El Pla del Real'
      },
      46004: {
        label: 'Campanar'
      },
      46005: {
        label: 'La Saïdia'
      }
    }
  }]
}, {
  id: 'ZARAGOZA',
  name: 'Saragosse',
  country: 'ES',
  cornerNW: {
    latitude: 41.6897,
    longitude: -0.9119
  },
  cornerSE: {
    latitude: 41.6261,
    longitude: -0.8341
  },
  subZones: [{
    name: 'Saragosse',
    zipcodes: {
      50001: {
        label: 'Casco Antiguo'
      },
      50002: {
        label: 'Las Fuentes'
      },
      50003: {
        label: 'La Almozara'
      },
      50004: {
        label: 'Centro'
      },
      50005: {
        label: 'Universidad'
      }
    }
  }]
}];
var esSubZoneNameMapping = exports.esSubZoneNameMapping = [{
  old: 'Barcelone',
  "new": 'Ciutat Viella'
}, {
  old: 'Madrid Salamanca',
  "new": '01 - Centro'
}, {
  old: 'Madrid Chueca',
  "new": '01 - Centro'
}, {
  old: 'Madrid Malasaña',
  "new": '07 - Chamberí'
}, {
  old: 'Madrid Centro histórico',
  "new": '01 - Centro'
}, {
  old: 'Madrid Chamartín',
  "new": '06 - Tetuán'
}, {
  old: 'Madrid Nuevos Ministerios',
  "new": '01 - Centro'
}, {
  old: 'Madrid San Blas',
  "new": '12 - Usera'
}, {
  old: 'Madrid Hortaleza',
  "new": '16 - Hortaleza'
}];